<template>
  <div class="page">
    <div class="card">
      <el-form ref="editForm" :model="formData" :rules="formRules" label-width="160px">
        <el-row>
          <el-col :md="24" :lg="18" :xl="12">
            <el-form-item :label="$t('setting.newPasswd')" prop="password">
              <el-input type="password" v-model.trim="formData.password" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$t('setting.confirmNewPasswd')" prop="rePassword">
              <el-input type="password" v-model.trim="formData.rePassword" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="submit">{{ $t('common.submit') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { updatePassword } from '../../api/setting';

export default {
  name: 'Passwd',
  data() {
    return {
      formData: {
        password: '',
        rePassword: '',
      },
      formRules: {
        password: [
          { required: true, message: this.$t('setting.pleaseEnterNewPasswd'), trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/, message: this.$t('setting.pleaseReEnter'), trigger: 'blur' },
        ],
        rePassword: [
          { required: true, message: this.$t('setting.pleaseEnterAgain'), trigger: 'blur' },
          { validator: this.validatePass2, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          this.$message('请填充所有必填信息');
        }
      });
    },
    submitForm() {
      updatePassword({
        newPassword: this.formData.password,
      }).then((res) => {
        if (res.success) {
          this.formData.password = '';
          this.formData.rePassword = '';
          this.$message.success(this.$t('error.successful'));
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    validatePass2(rule, value, callback) {
      if (this.formData.password !== this.formData.rePassword) {
        callback(new Error(this.$t('setting.passwordNotMatch')));
      } else {
        callback();
      }
    },
  },
};
</script>

<style scoped></style>
